export default __webpack_public_path__ + "static/media/sample-FP-L2.32d828f6.png";